export default function DeleteUnfilledIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={18}
        viewBox="0 0 14 16"
        fill="white"
      >
        <path
          d="M1.5 4.16602H2.77778H13"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.69401 4.16688V2.88911C4.69401 2.55022 4.82863 2.22521 5.06826 1.98558C5.30789 1.74595 5.6329 1.61133 5.97179 1.61133H8.52734C8.86623 1.61133 9.19124 1.74595 9.43087 1.98558C9.6705 2.22521 9.80512 2.55022 9.80512 2.88911V4.16688M11.7218 4.16688V13.1113C11.7218 13.4502 11.5872 13.7752 11.3475 14.0149C11.1079 14.2545 10.7829 14.3891 10.444 14.3891H4.05512C3.71623 14.3891 3.39123 14.2545 3.1516 14.0149C2.91197 13.7752 2.77734 13.4502 2.77734 13.1113V4.16688H11.7218Z"
          stroke="#000000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
